import styles from "./ButtonPanel.module.css";

interface ButtonPanelProps {
  children?: React.ReactNode;
  childrenPosition?: "left" | "center" | "right" | "in-between";
  inModal?: boolean;
}

function ButtonPanel({ children, childrenPosition = "right", inModal = true }: ButtonPanelProps) {
  const positionClass = styles[childrenPosition];
  return (
    <div
      className={`${inModal ? styles["button-panel-modal"] : styles["button-panel"]} ${positionClass}`}
    >
      {children}
    </div>
  );
}

export default ButtonPanel;
